export const fetchVetAttributes = (params) =>
  $.ajax({
    method: 'GET',
    url: '/vet-portal/vet_attributes',
    data: params,
  });

export const fetchPracticeAttributes = (params) =>
  $.ajax({
    method: 'GET',
    url: '/vet-portal/practice_attributes',
    data: params,
  });

export const fetchStateAttributes = (params) =>
  $.ajax({
    method: 'GET',
    url: '/vet-portal/state_attributes',
    data: params,
  });
